export const getScheduleTime = (schedule: Date): string => {
  if (schedule.getHours() === 23 && schedule.getMinutes() === 59) {
    return "00:00";
  }
  const hours =
    schedule.getHours() < 10 ? `0${schedule.getHours()}` : schedule.getHours();
  const minutes =
    schedule.getMinutes() < 10
      ? `0${schedule.getMinutes()}`
      : schedule.getMinutes();

  return `${hours}:${minutes}`;
};
